define((require, exports, module) => {
    'use strict';

    const UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function LocalFileNotFoundFail() {
        // eslint-disable-next-line prefer-rest-params
        UploadFail.apply(this, arguments);
    }

    /**
     * @param {DOMException|FileError} error
     * @returns {boolean}
     */
    LocalFileNotFoundFail.isNotFoundError = function(error) {
        let isNotFoundError = false;

        if (window.DOMException && error instanceof DOMException) {
            // Chrome
            isNotFoundError = error.code === DOMException.NOT_FOUND_ERR;
        } else if (window.FileError && error instanceof window.FileError) {
            // Safari
            isNotFoundError = error.code === window.FileError.NOT_FOUND_ERR;
        }

        return isNotFoundError;
    };

    LocalFileNotFoundFail.prototype = Object.assign(
        Object.create(UploadFail.prototype),
        {
            constructor: LocalFileNotFoundFail,
            className: 'LocalFileNotFoundFail',
            radarName: 'fail_{SOURCE}_local-file-not-found',
            message: [
                'Файл больше недоступен по указанному пути в локальной файловой системе.',
                'Возможно вы извлекли съемный диск, переименовали или удалили файл.',
            ].join(' '),
        },
    );

    module.exports = LocalFileNotFoundFail;
});
